import React from 'react'
import './unauth-user-dropdown.styles.scss'

import { Link } from 'react-router-dom'
import { version } from '@/changelog-version'
import { useSelector } from 'react-redux'

const UnuathUserDropdown = ({ show }) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const userProfile = useSelector(state => state.userData.userProfile);
    const root = useSelector(state => state.userData.root);
    const membership = useSelector(state => state.userData.membership);

    return (
        <div className={`${show ? 'active' : ''} unauth-dropdown-container ${screenSize} ${userProfile && userProfile.upload ? 'upload-user' : ''}`}>
            <div className="dropdown-menu">
                {
                    (userProfile && userProfile.gamePath)
                    ?
                    <Link to={`/play/${userProfile.gamePath}`}>My Game</Link>
                    :
                    <Link to='/loading'>My Games</Link>
                }
                {
                    (userProfile && !userProfile.upload) &&
                    <>
                    <Link to='/home/mycontent'>My Content</Link>
                    <Link to='/profile'>My Profile</Link>
                    <Link to='/myplan'>My Plan</Link>
                    <Link to ='/home/myorgs'>My Organizations</Link>
                    </>
                }
                {/* {
                    (membership && membership.membership > 0) &&
                    <a href='https://billing.stripe.com/p/login/test_9AQ2aK2Nj3jaaYM9AA' target="_blank">Manage My Plan</a>
                } */}
                <Link to='/logout'>Sign Out</Link>
                <div>
                    <span className='meta version'>
                        {version}
                    </span>
                    <Link to='/changelog' target='_blank'>
                        <span className='meta'>Change Log</span>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default UnuathUserDropdown;